{
  "title": "評分無法送出",
  "description": "點選「正式送出」評分後無法完成的排查方式。",
  "headings": ["症狀", "最常見原因", "排查方式", "正常結果", "仍無法解決"],
  "symptom": "點選「儲存草稿」或「正式送出」後出現錯誤，評分無法儲存或送出。",
  "causes": [
    "尚未針對每個評分項目都填寫分數",
    "分數超出該評分項目允許的範圍",
    "該競賽要求審查意見但尚未填寫",
    "已針對該作品申報利益迴避",
    "指派已標記為「已完成」，需請主辦方重新開啟"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "確認評分表上每一個評分項目都已填寫分數，且沒有重複或漏填。"
    },
    { "title": "Step 2", "description": "確認每個分數都落在該評分項目標示的允許範圍內。" },
    {
      "title": "Step 3",
      "description": "若畫面要求「審查意見」為必填（部分競賽設定），確認已填寫非空白內容。"
    },
    {
      "title": "Step 4",
      "description": "確認自己尚未針對該作品申報利益迴避；若已申報，該作品的評分功能會被系統拒絕，這是正常保護機制，非錯誤。"
    },
    {
      "title": "Step 5",
      "description": "若先前已送出過一次評分，指派狀態會轉為「已完成」，需請主辦方協助「重新開啟」該筆分數後才能再次修改送出。"
    }
  ],
  "resolution": "修正上述問題後，「儲存草稿」與「正式送出」應可正常使用。",
  "stillStuck": ["競賽名稱", "作品匿名代碼", "發生時間", "錯誤訊息", "Screenshot"],
  "doNotProvide": ["密碼", "驗證碼", "Token"],
  "nextSteps": "確認後仍卡住，請見「如何評分並正式送出」重新走一次完整步驟。"
}
